import { FC } from "react";
import { useLocation } from "react-router-dom";

import { translation as t } from "../utils/translation";

const Disclaimer: FC = () => {
  const location = useLocation();
  return (
    <div className="container mx-auto xxl:px-20 xxl:py-10 xs:px-1 xs:pt-[50px] xs:pb-[20px] xxl:pb-[20px] text-grey xs:text-[13px] xxl:text-[16px] font-normal">
      {t.DISCLAIMER}
      {location.pathname==="/Calc" && <div>{t.MORE_DISCLAIMER_MIX}</div>}
    </div>
  );
};

export default Disclaimer;
